//react
import { useEffect, useRef, useState } from "react";

//Libs
import { datadogLogs } from "@datadog/browser-logs";
import toast from "react-hot-toast";

//Components
import AutoCapture from "./AutoCapture";
import ManualCapture from "./ManualCapture";

//redux
import { store } from "../../../lib/store.js";
import { getInstance } from "../../../lib/slices/assure";

//Hooks
import RoundLoader from "../../../Hooks/RoudLoader.js";

//Utils
import { hasRealCameraSupport } from "../../../Utils/cameraValidation.js";
import { getDeviceContext } from "../../../Utils/deviceValidation.js";

const AcuantCamera = ({
    responseScan,
    tenantColor,
    tenantImage,
    tenantName,
}) => {
    const [instance, setInstance] = useState();
    const { dispatch } = store;
    const [loading, setLoading] = useState(false);
    const hasLoggedCameraModeRef = useRef(false);
    const cameraModeSupported = hasRealCameraSupport();

    const queryInstance = async (responseScan) => {
        try {
            setLoading(true);
            var data = { responseScan };

            const instance = await dispatch(
                getInstance({
                    data,
                })
            );
            if (!instance?.error) {
                setInstance(instance?.payload?.instance);

                datadogLogs.logger.info(
                    `Instance set (AcuantReactCamera) with the invitationId: ${responseScan?.invitation_id}`,
                    {
                        invitationId: responseScan?.invitation_id,
                        instance: instance,
                    }
                );
            } else {
                toast.error(
                    "Error to try to get the instance, please try again later."
                );
                datadogLogs.logger.error(
                    `Error loading Acuant Instance (AcuantReactCamera) with the invitationId: ${responseScan?.invitation_id}`,
                    {
                        invitationId: responseScan?.invitation_id,
                        error: instance,
                        message: "Error loading Acuant Instance",
                    }
                );
            }
        } catch (error) {
            toast.error("Error to try to get the instance, please try again later.");
            datadogLogs.logger.error(
                `Error processing instance (AcuantReactCamera) with the invitationId: ${responseScan?.invitation_id}`,
                {
                    invitationId: responseScan?.invitation_id,
                    message: "Error processing instance",
                    error: error,
                }
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (responseScan !== undefined && !responseScan !== null) {
            queryInstance(responseScan);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [responseScan]);

    useEffect(() => {
        if (loading || hasLoggedCameraModeRef.current) return;
        hasLoggedCameraModeRef.current = true;
        datadogLogs.logger.info(
            `Capture mode selected (AcuantCamera) with the invitationId: ${responseScan?.invitation_id}`,
            {
                invitationId: responseScan?.invitation_id,
                mode: cameraModeSupported ? "AutoCapture" : "ManualCapture",
                hasRealCameraSupport: cameraModeSupported,
                ...getDeviceContext(),
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);

    return (
        <>
            {loading ? (
                <section className="flex justify-center items-center min-h-screen flex-col gap-3 container px-3 py-5 bg-[#F8F7F6] w-full">
                    <RoundLoader
                        loading={true}
                        color={tenantColor}
                        responseScan={responseScan}
                        tenantImage={tenantImage}
                        tenantName={tenantName}
                    />
                </section>
            ) : (
                <>
                    {cameraModeSupported ? (
                        <AutoCapture
                            instance={instance}
                            responseScan={responseScan}
                            tenantColor={tenantColor}
                            tenantImage={tenantImage}
                            tenantName={tenantName}
                        />
                    ) : (
                        <ManualCapture
                            instance={instance}
                            responseScan={responseScan}
                            tenantColor={tenantColor}
                            tenantImage={tenantImage}
                            tenantName={tenantName}
                        />
                    )}

                </>
            )}
        </>
    );
};

export default AcuantCamera;
